import { ScreenId } from "@/js/value-objects/screen-id";
export class LalertEvacuationScreenMode {
  // 新規作成
  static CREATE = "lalert-evacuation-create";
  // 編集
  static EDIT = "lalert-evacuation-edit";
  // 参照
  static VIEW = "lalert-evacuation-view";
  // コピーして編集
  static DUPLICATE = "lalert-evacuation-duplicate";

  /**
   * コンストラクタ
   * @param {*} value Routerのname属性
   */
  constructor(value) {
    this.value = value;
  }
  /**
   * インスタンス生成
   * @param {*} value Routerのname属性
   * @returns LalertEvacuationScreenModeインスタンス
   */
  static factory(value) {
    return new LalertEvacuationScreenMode(value);
  }
  /**
   * モード判定（新規作成）
   * @returns true：「新規作成」モード、false：「新規作成」モード以外
   */
  isCreate() {
    return this.value === LalertEvacuationScreenMode.CREATE;
  }
  /**
   * モード判定（編集）
   * @returns true：「編集」モード、false：「編集」モード以外
   */
  isEdit() {
    return this.value === LalertEvacuationScreenMode.EDIT;
  }
  /**
   * モード判定（参照）
   * @returns true：「参照」モード、false：「参照」モード以外
   */
  isView() {
    return this.value === LalertEvacuationScreenMode.VIEW;
  }
  /**
   * モード判定（コピーして編集）
   * @returns true：「コピーして編集」モード、false：「コピーして編集」モード以外
   */
  isDuplicate() {
    return this.value === LalertEvacuationScreenMode.DUPLICATE;
  }
  /**
   * 画面ID取得
   * @returns 画面ID
   */
  getScreenId() {
    let screenId = "";
    switch (this.value) {
      case LalertEvacuationScreenMode.CREATE:
        // 新規登録
        screenId = ScreenId.SF2105;
        break;
      case LalertEvacuationScreenMode.EDIT:
        // 編集
        screenId = ScreenId.SF2105;
        break;
      case LalertEvacuationScreenMode.VIEW:
        // 参照
        screenId = ScreenId.SF2104;
        break;
      case LalertEvacuationScreenMode.DUPLICATE:
        // コピーして編集
        screenId = ScreenId.SF2105;
        break;
      default:
        break;
    }
    return screenId;
  }
}
